import React from 'react';
import { Card } from 'react-bootstrap';

const Monitoring = () => {
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Monitoreo del Sistema</h2>
      </div>

      <Card>
        <Card.Body className="text-center py-5">
          <i className="bi bi-graph-up fs-1 text-muted mb-3"></i>
          <h5 className="text-muted">Funcionalidad de Monitoreo</h5>
          <p className="text-muted">Esta sección estará disponible próximamente</p>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Monitoring;